import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import OAuthConsentPage from '@/pages/oauth/consent'

const searchSchema = z.object({
  client_id: z.string(),
  redirect_uri: z.string(),
  scope: z.string().optional().default(''),
  code_challenge: z.string(),
  state: z.string().optional(),
  resource: z.string().optional(),
})

export const Route = createFileRoute('/oauth/consent')({
  validateSearch: searchSchema,
  component: OAuthConsentPage,
})
